import React from 'react';
import { FiCheckCircle } from 'react-icons/fi';
import { Box, Container, Typography } from '@material-ui/core';

import PageTitle from '../../components/PageTitle';

import { expiredLinkErrorStyles } from './styles';

function ExpiredLinkError() {
  const classes = expiredLinkErrorStyles();

  return (
    <Box mt={5} mb={8}>
      <Container>
        <PageTitle title="Central de Montagem" />
        <Box className={classes.boxIcon}>
          <FiCheckCircle size={90} />
        </Box>
        <Box mt={5} mb={3} textAlign="center">
          <Typography component="div">
            <Box fontSize={34} fontWeight="bold" mb={3} lineHeight={1.2}>
              O seu produto já foi montado.
            </Box>
          </Typography>
          <Box className={classes.boxText}>
            <Typography>
              Caso você tenha alguma dúvida ou problemas com o seu produto
              montado, entre em contato com a central de montagem através do{' '}
              <strong>{process.env.REACT_APP_CENTRAL_PHONE_NUMBER}</strong>.
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default ExpiredLinkError;
